import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

interface GroupState {
  selectedGroupId: string | null;
  selectedOfficeId: string | null; // 그룹에 office_id가 연결되어 있을 수 있으므로 함께 관리
  setSelectedGroupId: (id: string | null) => void;
  setSelectedOfficeId: (id: string | null) => void;
}

export const useGroupStore = create<GroupState>()(
  persist(
    (set) => ({
      selectedGroupId: null,
      selectedOfficeId: null,
      setSelectedGroupId: (id) => set({ selectedGroupId: id }),
      setSelectedOfficeId: (id) => set({ selectedOfficeId: id }),
    }),
    {
      name: "group-selection-storage", // localStorage에 저장될 키 이름
      storage: createJSONStorage(() => localStorage), // localStorage 사용
      partialize: (state) => ({
        // selectedGroupId와 selectedOfficeId만 persist
        selectedGroupId: state.selectedGroupId,
        selectedOfficeId: state.selectedOfficeId,
      }),
    }
  )
);
